import { Box, Typography } from "@mui/material";
import {
  stepperContainer,
  stepperTitle,
  stepperText,
  stepIndicatorCircle,
  stepTrackerContainer,
  stepTrackerLine,
} from "./AssignmentFormsStepperStyles";
import BlackCheckFilled from "@assets/svgs/checks/black_check_filled.svg";

interface AssignFormsStepperProps {
  title: string;
  stepOne: string;
  stepTwo: string;
  currentStepNumber: number;
}

export const AssignFormsStepper = ({
  title,
  stepOne,
  stepTwo,
  currentStepNumber,
}: AssignFormsStepperProps) => {
  return (
    <Box sx={stepperContainer}>
      <Box sx={stepperTitle}>{title}</Box>
      <Box sx={stepTrackerContainer}>
        <Box sx={stepIndicatorCircle}>
          {currentStepNumber === 2 ? (
            <img
              src={BlackCheckFilled}
              alt="Completed step"
              style={{ width: "16px", height: "16px" }}
            />
          ) : (
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#000",
                lineHeight: "normal",
              }}
            >
              1
            </Typography>
          )}
        </Box>
        <Typography sx={stepperText}>{stepOne}</Typography>
        <Box sx={stepTrackerLine} />
        <Box
          sx={{
            ...stepIndicatorCircle,
            background:
              currentStepNumber === 2
                ? "var(--primary-main-f-7-b-500, #F7B500)"
                : "var(--Grey-400, #BDBDBD)",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              color: "#000",
              lineHeight: "normal",
            }}
          >
            2
          </Typography>
        </Box>
        <Typography sx={stepperText}>{stepTwo}</Typography>
      </Box>
    </Box>
  );
};
